module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-with-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("TO THREE LITTLE KATHARINES")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Oh, Katharines three,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Come sail with me")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Where the ship of my Fancy flies!")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("We’ll wander free")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Over land and sea,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Then sail away to the skies.")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("If I were a star,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("So far—so far—")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("From this Earth where the children dwell,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("My twinkliest beam")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("For that ship should gleam;")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("And my truest secret I’d tell")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("To the eyes that look")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Through fancy.—No book")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center dedication-content"
  }, [_c('i', [_vm._v("Nor telescope serves so well.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5f11214","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/to-three-little-katharines.vue
// module id = 72
// module chunks = 0